var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExpertEnabled && _vm.expert)?_c('div',{staticClass:"has-background-danger featured-icon has-text-white tag\n  has-text-weight-semibold is-marginless is-expert-badge"},[_vm._v(" "+_vm._s(_vm.expertBadge)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }